import "moment-timezone";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { Button, DropdownButton, MenuItem, Modal } from "react-bootstrap";
import Datetime from "react-datetime";
import Alert from "react-s-alert";
import TrialCoachingSessionsService from "../utils/TrialCoachingSessionsService";
import ReferenceService from "../utils/ReferenceService";
import DealsService from "../utils/DealsService";

const SendBulkSmsModal = ({ showModal, onConfirmModal, onCloseModal }) => {
  const [tcsDate, setTcsDate] = useState(moment().add(2, "days"));
  const [smsGroupMessages, setSmsGroupMessages] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [dealIds, setDealIds] = useState([]);

  useEffect(() => {
    ReferenceService.get("sms_group_messages").then(data => {
      setSmsGroupMessages(data || []);
    });
  }, []);

  useEffect(() => {
    // get deals for selected date
    const params = {
      tcs_date: tcsDate
    };
    DealsService.getDealsForDate(params).then(data => {
      setDealIds(data.deal_ids);
    });
  }, [tcsDate]);

  const sendBulkMessage = () => {
    const params = {
      deal_ids: dealIds,
      tcs_date: tcsDate,
      message_item: selectedTemplate
    };
    DealsService.sendBulkMessage(params)
      .then(response => {
        Alert.success(
          "Bulk SMS are being sent in the background — check Reporting for updates."
        );
        onCloseModal();
      })
  };

  const handleTemplateSelect = index => {
    setSelectedTemplate(smsGroupMessages[index]);
  };

  return (
    <Modal show={showModal} onHide={onCloseModal} dialogClassName="modal-lg">
      <Modal.Header closeButton>
        <Modal.Title>Send Bulk SMS</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="form-group mb-4">
          <div className="mb-2">
            <strong className="mb-1">Notes:</strong>
            <div>
              - Bulk SMS messages are sent to all parent contacts associated
              with the deal.
            </div>
            <div>
              - Completed, Dead Deals & on Hold deals are excluded from the
              list.
            </div>
            <div>
              - They are processed as background jobs, and each execution is
              logged under the Reporting tab.
            </div>
          </div>
          <div className="mb-3">
            <label className="d-block">Select Date:</label>
            <Datetime
              inputProps={{ className: "" }}
              onChange={v => setTcsDate(v)}
              value={tcsDate}
              closeOnSelect={true}
              dateFormat="DD MMM YYYY"
              timeFormat={false}
            />
            <div id="bulk-sms-selected-deal-ids">
              {dealIds.map(id => (
                <div
                  key={id}
                  id="bulk-sms-deal-id"
                  className="bulk-sms-deal-id  flex items-center border border-gray-300 text-sm px-2 py-1 rounded-full text-gray-700"
                >
                  <span className="mr-2">Deal # {id}</span>
                  <button
                    onClick={() => setDealIds(dealIds.filter(d => d !== id))}
                    className="text-gray-500 hover:text-red-500 focus:outline-none"
                    aria-label="Remove"
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div>
            <label className="d-block strong">Select Template:</label>
            <div id="dropdown-group-actions-bulk-wrapper">
              <DropdownButton
                bsStyle="info"
                bsSize="small"
                title="Choose Template"
                id="dropdown-group-actions"
                renderMenuOnMount={true}
              >
                {smsGroupMessages.map((item, index) => (
                  <MenuItem
                    key={index}
                    eventKey={index}
                    onClick={() => handleTemplateSelect(index)}
                  >
                    {item.description}
                  </MenuItem>
                ))}
              </DropdownButton>
            </div>
            {selectedTemplate && (
              <div className="mt-2 p-2">
                <strong className="mb-1">Selected Template:</strong>
                <div className="mb-1">{selectedTemplate.description}</div>
                <div>
                  <strong className="mb-1">Body:</strong>
                  <div>{selectedTemplate.template_text}</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={onCloseModal}>Whoops, cancel this</Button>
        <Button
          onClick={sendBulkMessage}
          disabled={!selectedTemplate || dealIds.length < 1}
          bsStyle="success"
        >
          Send Bulk Sms
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SendBulkSmsModal;
